import React from "react";
import { Box } from "@material-ui/core";

import Icon from "assets/BGC-login-icon.svg";
import { color, fontSize, spacingDefaults } from "style/constants";
import BGCInfoPage from "./BGCInfoPage";
import InstructionsBox from "./InstructionsBox";
import StoreLinks from "./StoreLinks";
import UserNameBadge from "./UserNameBadge";

interface PageFourProps {
  registrationCode: string;
}

const instructions = [
  "Copy the username above",
  "Download the BGC App",
  "Register your account in the app with the above login",
  "Begin the assigned tasks"
];

const PageFour: React.FC<PageFourProps> = ({ registrationCode }) => (
  <BGCInfoPage
    icon={Icon}
    iconAlt="BGC login icon"
    heading="Here is your unique login information"
  >
    <UserNameBadge code={registrationCode} />

    <Box
      marginTop={spacingDefaults.normal}
      marginBottom={spacingDefaults.large}
      style={{ color: color.BLUE, fontSize: fontSize.medium }}
    >
      Server code: <strong>daltest</strong>
    </Box>

    <InstructionsBox instructions={instructions} />

    <StoreLinks />
  </BGCInfoPage>
);

export default PageFour;
